<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :selectedCategory="seletedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="[]"
        searchText="Search Quarter"
        @searchByParameter="searchByParams" />
    </portal>

    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft" />
      </div>
    </div>

    <div class="top slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div
        class="slideleft_content"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10">
        <MdmHeader
          :headers="sectionHeaders"
          :noCheckbox="true" />
        <div v-if="isLoading" class="paymentloader"></div>
        <div v-else-if="list.length === 0" class="emptydiv">
          <div class="paymentempty"></div>
          <div class="emptytext">No data found!</div>
        </div>
        <MdmRow
          v-else
          v-for="(entry, index) in ndcList"
          :key="index"
          :data="entry"
          :headers="sectionHeaders"
          :showEdit="true"
          v-on:edit="openDetail(entry)" />
      </div>

      <div class="slideleft_menu">
        <SecFilter
          v-if="!isLoading"
          :selectedFilters="filterConstant"
          :filters="ndcFilters"
          @search="searchApply"
          @updateOption="updateOption"
          @reset="resetApply"
          @clearDate="clearDate" />
      </div>
    </div>

    <div class="slideleft_drawer">
      <div class="slideleft_content">
        <div class="content pt-20" v-if="showForm">
          <Drawer
            :visible.sync="showForm"
            direction="rtl"
            size="700px"
            :modal="true"
            :withHeader="false"
            :append-to-body="true"
            class="default-drawer">
            <Link :underline="false" class="nav-close" @click="closeSlider">
              <svgicon name="cancelwhite" width="12" height="12" :original="true" />
            </Link>
            <NdcSubmissionDetail
              v-if="selectedRow"
              :entry="selectedRow"
              @close="closeSlider"
              @uploaded="onUpdated"
              @deleted="onUpdated" />
          </Drawer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from '@common/components/mdm-v2/Row';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdmV2 from '@/components/mixins/SharedMdmV2';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import FilterWrapper from '@common/components/FilterWrapperV2';
import { filters, documentOptions } from '@/constants/mdm-v2/ndc';
import { showNdcEntry } from '@/api-factory/ndc';
import NdcSubmissionDetail from '@/components/modules/ndc/NdcSubmissionDetail';

const MAX_DISPLAY_COLUMN = 4;

export default {
  components: {
    PrimaryFilter,
    MdmHeader,
    MdmRow,
    SecFilter,
    FilterWrapper,
    NdcSubmissionDetail,
  },
  mixins: [SharedMdmV2, SecFilterMixin],
  data() {
    return {
      openSlideleft: false,
      skipEditPermission: true,
      overrideDefaultSearchParms: true,
      filterConstant: [],
      ndcFilters: filters,
      defaultValues: {},
      allDocumentOptions: documentOptions,
      searchedParams: {},
    };
  },
  computed: {
    searchParameters() {
      return (this.searchConstants && this.searchConstants.ndc_master) || [];
    },
    ndcList() {
      return (this.list || []).map(entry => ({
        ...entry,
        updated_date: entry.updated_at ? moment(entry.updated_at).format('DD MMM YYYY') : '-',
      }));
    },
  },
  async created() {
    this.loadSearchFromSession();
    this.setDefaults();
    this.constructConstantForFilter();
    this.loadFilterFromSession();
    this.loadMore();
  },
  methods: {
    setConstants() {
      this.currentSection = 'ndc_master';
      this.sectionHeaders = (this.listHeaders && this.listHeaders.ndc_master) || [];
      this.addFormConstants = [];
    },
    async loadMore() {
      try {
        this.$store.commit('mdmV2/SET_LOADING', true);
        const params = { page: this.filter.page || 1 };
        if (this.filterParams && Object.keys(this.filterParams).length) {
          Object.assign(params, this.filterParams);
        }
        if (this.searchedParams && Object.keys(this.searchedParams).length) {
          Object.assign(params, this.searchedParams);
        }
        const result = await this.$store.dispatch('mdmV2/search', {
          section: this.currentSection,
          params,
        });
        this.loadCheck = this.hasEmpty;
      } catch (error) {
        console.error('[NdcMaster] error:', error);
      } finally {
        this.$store.commit('mdmV2/SET_LOADING', false);
      }
    },
    setDefaults() {
      [this.defaultValues.document] = this.allDocumentOptions;
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'List',
            category: filters.document,
            default: this.defaultValues.document,
            selected: this.defaultValues.document,
            list: this.allDocumentOptions,
            idLabel: 'id',
            queryParamString: 'document_filter',
            optional: true,
          },
        ],
      ];
    },
    loadFilterFromSession() {
      this.loadFilters();
      this.applyFilters();
      this.filterParams = this.constructFilterPayload();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON =
        localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = { ...this.searchedParams, ...sessionSearchParams };
    },
    saveSearchToSession() {
      const sessionSearch = JSON.stringify(this.searchedParams);
      localStorage.setItem(`${this.$route.name}-search-popup`, sessionSearch);
    },
    searchByParams(params) {
      this.searchByParameter(params);
      this.saveSearchToSession();
    },
    async openDetail(entry) {
      const detail = await showNdcEntry(entry.id);
      this.selectedRow = detail;
      this.showForm = true;
    },
    closeSlider() {
      this.showForm = false;
      this.selectedRow = null;
    },
    onUpdated(updatedEntry) {
      this.$store.commit('mdmV2/setPage', 1);
      this.loadMore();
      if (updatedEntry) {
        this.selectedRow = updatedEntry;
      } else {
        this.closeSlider();
      }
    },
    searchApply() {
      this.applyFilters();
      this.openSlideleft = false;
      const filter = this.constructFilterPayload();
      this.searchByFilter(filter);
    },
    resetApply() {
      this.resetAll();
      this.searchApply();
    },
  },
};
</script>
